import {useIntl} from 'react-intl'
import {useListView} from '../core/ListViewProvider'
import dataAxios from '../../../../modules/auth/core/dataAxios'
import {useQueryRequest} from '../core/QueryRequestProvider'
import {buildUserApiQuery} from '../core/userListQuery'

const API_URL = process.env.REACT_APP_API_URL || ''

const apiBase = () => (API_URL || '').replace(/\/api\/?$/i, '')

type Props = {
  filters: {page: number; size: number; status: string; role: string}
}

const UserListToolbar = ({filters}: Props) => {
  const intl = useIntl()
  const {setItemIdForUpdate} = useListView()
  const {state} = useQueryRequest()

  const runExport = async (exportAs: 'excel' | 'csv') => {
    try {
      const exportParams = buildUserApiQuery(state, {
        listScope: 'team',
        ...(state.search ? {searchUser: state.search} : {}),
        ...(filters.status ? {status: filters.status} : {}),
        ...(filters.role ? {role: filters.role} : {}),
      })
      const res = await dataAxios.get(`${API_URL.replace(/\/$/, '')}/export`, {
        params: {dataType: 'users', exportAs, ...exportParams},
      })
      const raw = res.data?.data?.url as string | undefined
      if (!raw) {
        return
      }
      const rel = raw.replace(/^\.\//, '')
      window.open(`${apiBase()}/${rel}`, '_blank', 'noopener,noreferrer')
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <div className='d-flex flex-wrap gap-2 justify-content-end' data-kt-user-table-toolbar='base'>
      <button
        type='button'
        className='btn btn-light-primary btn-sm'
        onClick={() => runExport('csv')}
      >
        {intl.formatMessage({id: 'USERS.EXPORT.CSV'})}
      </button>
      <button
        type='button'
        className='btn btn-light-primary btn-sm'
        onClick={() => runExport('excel')}
      >
        {intl.formatMessage({id: 'USERS.EXPORT.EXCEL'})}
      </button>
      <button
        type='button'
        className='btn btn-primary btn-sm'
        onClick={() => setItemIdForUpdate('new')}
      >
        {intl.formatMessage({id: 'USERS.ACTION.ADD'})}
      </button>
    </div>
  )
}

export {UserListToolbar}
